import { Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { LanguageSwitch } from "@components/languageSwitch";

import { Contact } from "./Contact";
import { FooterContainer, StyledPageElementContainer } from "./Footer.styled";
import { FooterHeader } from "./FooterHeader";
import { KnowledgeBase } from "./KnowledgeBase";
import { LetsMeet } from "./LetsMeet";
import { LetsTalk } from "./LetsTalk";
import { Links } from "./Links";
import { ServiceLinks } from "./ServiceLinks";

const Footer = () => {
  const theme = useTheme();

  return (
    <StyledPageElementContainer>
      <FooterContainer>
        <FooterHeader />

        <Grid
          container
          rowSpacing={"48px"}
          sx={{ mt: "24px" }}
          columns={{ mobile: 8, tablet: 16, desktop: 24, desktopXl: 24 }}
        >
          <Grid item mobile={9} desktop={9}>
            <LetsTalk />
          </Grid>

          <Grid item mobile={7} desktop={7}>
            <LetsMeet />
          </Grid>

          <Grid item mobile={8} tablet={16} desktop={8}>
            <Contact />
          </Grid>

          <Grid item mobile={12} tablet={16} desktop={24}>
            <KnowledgeBase />
          </Grid>

          <Grid
            item
            mobile={12}
            tablet={16}
            desktop={16}
            sx={{
              alignSelf: "flex-end",
              [theme.breakpoints.up("desktop")]: {
                order: 4,
              },
            }}
          >
            <Links />
          </Grid>

          <Grid
            item
            mobile={4}
            desktop={8}
            sx={{
              [theme.breakpoints.up("desktop")]: {
                order: 3,
              },
            }}
          >
            <LanguageSwitch variant="code1" />
          </Grid>
        </Grid>

        <hr className="my-16" />

        <ServiceLinks />
      </FooterContainer>
    </StyledPageElementContainer>
  );
};

export default Footer;
